import { useCallback } from "react"
import { graphql, useMutation, UseMutationConfig } from "react-relay"
import { useChDeleteSickLeaveMutation as useChDeleteSickLeaveMutationType } from "@/modules/patients/detail/sick-leave-certificate/ch/services/__generated__/useChDeleteSickLeaveMutation.graphql"

const deleteSickLeaveMutation = graphql`
  mutation useChDeleteSickLeaveMutation($input: Ch_deleteSickLeaveInput!) {
    ch_deleteSickLeave(input: $input) {
      ch_SickLeave {
        id @deleteRecord
      }
    }
  }
`

const useChDeleteSickLeaveMutation = () => {
  const [commit, isFlight] = useMutation<useChDeleteSickLeaveMutationType>(deleteSickLeaveMutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChDeleteSickLeaveMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChDeleteSickLeaveMutation }
